import React, { Fragment } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Dropdown } from "semantic-ui-react";

const ClassTemplatesDropdown = (props) => {
    const { onChange, value, classN, req, id, disabled, options } = props;
    const { t } = useTranslation();

    return (
        <Fragment>
            <Form.Group className={classN ? classN : "mb-3"}>
                <Form.Label>
                    {t(`classes.classesTemplate`)} {req && <span className="text-danger">*</span>}
                </Form.Label>

                <Dropdown placeholder={t("choose")} fluid selection options={options} onChange={(e, data) => onChange(data.value)} value={value} id={id} disabled={disabled} />
            </Form.Group>
        </Fragment>
    );
};

export default ClassTemplatesDropdown;
